"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaLibrary = void 0;
var constants_1 = require("../constants");
var fragments_1 = require("../utils/fragments");
var MediaLibrary = /** @class */ (function () {
    function MediaLibrary() {
    }
    Object.defineProperty(MediaLibrary, "MediaLibraryFragment", {
        get: function () {
            return (0, fragments_1.getFragment)(constants_1.FRAGMENTS_NAMES.mediaLibrary);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MediaLibrary, "Uploader", {
        get: function () {
            return this.MediaLibraryFragment.Uploader;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Returns media from upload list;
     * If returned value was null - consider element uploaded finished;
     * @param {string} relatedEntityId - related entity (content block, question, etc) id;
     * @returns { MediaEntityTypes | null }
     */
    MediaLibrary.getMediaByIdentifier = function (relatedEntityId) {
        return this.Uploader.getMediaByIdentifier(relatedEntityId);
    };
    MediaLibrary.uploadImageFromPc = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.Uploader.uploadImageFromPc(options)];
            });
        });
    };
    MediaLibrary.uploadDocumentFromPc = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.Uploader.uploadDocumentFromPc(options)];
            });
        });
    };
    MediaLibrary.uploadAudioFromPc = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.Uploader.uploadAudioFromPc(options)];
            });
        });
    };
    MediaLibrary.uploadAudioFromRecording = function (blob) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.Uploader.uploadAudioFromRecording(blob)];
            });
        });
    };
    MediaLibrary.uploadVideoFromPc = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.Uploader.uploadVideoFromPc(options)];
            });
        });
    };
    MediaLibrary.uploadDroppedImageFromPc = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.Uploader.uploadDroppedImageFromPc(event)];
            });
        });
    };
    MediaLibrary.uploadDroppedDocumentFromPc = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.Uploader.uploadDroppedDocumentFromPc(event)];
            });
        });
    };
    MediaLibrary.uploadDroppedAudioFromPc = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.Uploader.uploadDroppedAudioFromPc(event)];
            });
        });
    };
    MediaLibrary.uploadDroppedVideoFromPc = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.Uploader.uploadDroppedVideoFromPc(event)];
            });
        });
    };
    MediaLibrary.uploadFiles = function (files, type) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.Uploader.uploadFiles(files, type)];
            });
        });
    };
    MediaLibrary.waitUntilUploaded = function (model) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        model.on(constants_1.MODEL_EVENTS.loaded, function (data) {
                            model.off();
                            resolve(data);
                        });
                        model.on(constants_1.MODEL_EVENTS.failed, function () {
                            model.off();
                            reject();
                        });
                    })];
            });
        });
    };
    MediaLibrary.openChooseAudioFromLibraryDialog = function (selectedItemIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.MediaLibraryFragment.openChooseFromLibraryDialog({
                        selectedItemIdentifier: selectedItemIdentifier,
                        component: constants_1.MEDIA_LIBRARY_COMPONENTS_TYPE.audioLibraryPage
                    })];
            });
        });
    };
    MediaLibrary.openChooseVideoFromLibraryDialog = function (selectedItemIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.MediaLibraryFragment.openChooseFromLibraryDialog({
                        selectedItemIdentifier: selectedItemIdentifier,
                        component: constants_1.MEDIA_LIBRARY_COMPONENTS_TYPE.videoLibraryPage
                    })];
            });
        });
    };
    MediaLibrary.openChooseImageFromLibraryDialog = function (selectedItemIdentifier, shouldShareStore) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.MediaLibraryFragment.openChooseFromLibraryDialog({
                        selectedItemIdentifier: selectedItemIdentifier,
                        shouldShareStore: shouldShareStore,
                        component: constants_1.MEDIA_LIBRARY_COMPONENTS_TYPE.imageLibraryPage
                    })];
            });
        });
    };
    MediaLibrary.openChooseImageFromStockLibraryDialog = function (shouldShareStore) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.MediaLibraryFragment.openChooseFromLibraryDialog({
                        showImageStockLibrary: true,
                        shouldShareStore: shouldShareStore,
                        component: constants_1.MEDIA_LIBRARY_COMPONENTS_TYPE.imageStockLibrary
                    })];
            });
        });
    };
    MediaLibrary.openChooseDocumentFromLibraryDialog = function (selectedItemIdentifier, allowedFormats) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.MediaLibraryFragment.openChooseFromLibraryDialog({
                        selectedItemIdentifier: selectedItemIdentifier,
                        component: constants_1.MEDIA_LIBRARY_COMPONENTS_TYPE.documentsLibraryPage,
                        allowedFormats: allowedFormats
                    })];
            });
        });
    };
    MediaLibrary.openVideoRecordingDialog = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.MediaLibraryFragment.openVideoRecordingDialog()];
            });
        });
    };
    MediaLibrary.openTrimMediaDialog = function (mediaType, media, isNewRecording) {
        if (isNewRecording === void 0) { isNewRecording = false; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.MediaLibraryFragment.openTrimMediaDialog(mediaType, media, isNewRecording)];
            });
        });
    };
    MediaLibrary.openTextToSpeechDialog = function (category, audioModel) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.MediaLibraryFragment.openTextToSpeechDialog(category, audioModel)];
            });
        });
    };
    MediaLibrary.openSubtitlesDialog = function (videoId, courseId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.MediaLibraryFragment.openSubtitlesDialog(videoId, courseId)];
            });
        });
    };
    return MediaLibrary;
}());
exports.MediaLibrary = MediaLibrary;
